export const MESSAGE_FROM_TYPE = 'MESSAGE_FROM_TYPE'
export const BUTTON_RADIO_TYPE = 'BUTTON_RADIO_TYPE'
export const INPUT_TEXT_TYPE = 'INPUT_TEXT_TYPE'
export const INPUT_PHONE_TYPE = 'INPUT_PHONE_TYPE'
export const INPUT_EMAIL_TYPE = 'INPUT_EMAIL_TYPE'
export const TEXTAREA_TYPE = 'TEXTAREA_TYPE'
export const CHECKBOX_TYPE = 'CHECKBOX_TYPE'
export const DEMO_TYPE = 'DEMO_TYPE'
export const HIDDEN_TYPE = 'HIDDEN_TYPE'
export const NEXT_TYPE = 'NEXT_TYPE'
export const SUBMIT_TYPE = 'SUBMIT_TYPE'
export const USER_TYPE = 'USER_TYPE'
